export const widgetTypes = {
	SUBHEADER: 'SUBHEADER',
	INCIDENTS: 'INCIDENTS',
	ORDERS: 'ORDERS',
	ISSUES: 'ISSUES',
	FAQ: 'FAQ',
	SUMMARY: 'SUMMARY',
	FAQ_LIST: 'FAQ_LIST',
	OHC: 'OHC',
	GST: 'GST'
};

export const ISSUE_TRACKER = {
	helpV2: 'CS',
	trackOrder: 'TrackOrders',
	manageOrder: 'ManageOrders',
	returnOrder: 'ReturnAndRefunds',
	contactSeller: 'contactSeller'
};

export const CHAT_TYPES = {
	OHC: 'OHC', // OldHelpCentre - Non-order Chat
	EHC: 'EHC' // Flipkart/Shopsy order chat v2
};

export const CHAT_TENANTS = {
	FLIPKART: 'flipkart_cx',
	SHOPSY: 'shopsy_cx'
};

export const INVOICE_DOWNLOAD = {
	IN_PROGRESS: 'Downloading Invoice in progress',
	SUCCESS: 'Invoice Downloaded Successfully',
	ERROR: 'Error while processing your request.'
};